import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

const styles = theme => ({
	section: {
		'padding-top': '0.6em',
		'padding-bottom': '0.6em',

		"background-color": "#dfdfdf"
	},
	title:{
		margin: 0,
		color: "rgba(0, 0, 0, 0.87)",
		fontSize: '1.25em'
	}
});

function SettingsSection(props) {
	// console.log(props);
	const { name, children, classes } = props;
	return (
		<List component="ul" style={{padding:0}}>
			<ListItem className={classes.section}>
				<p className={classes.title}>{name}</p>
			</ListItem>
			{children}
		</List>
	);
}

SettingsSection.propTypes = {
	name: PropTypes.string.isRequired,
	children: PropTypes.array.isRequired,

	classes: PropTypes.shape({
		section: PropTypes.string.isRequired,
		title: PropTypes.string.isRequired,
	}).isRequired,

};

export default withStyles(styles)(SettingsSection);
